module.exports = __webpack_public_path__ + "img/logo.b3bba7a9.svg";